import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from "../GlobalContexts/UserContext.js";

export default function UnAuthenticatedRoute({ children, ...rest }) {
  const { user } = useContext(UserContext);

  const redirect = querystring("redirect");

  return (
    <Route {...rest}>
      {/* {children} */}
      {user !== null ? (
        !user.isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={redirect === "" || redirect === null ? "/invest" : redirect}
          />
        )
      ) : (
        children
      )}
    </Route>
  );
}

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
